import styled from 'styled-components';
import Icon from '../Icon';

export const ModalWrapperStyled = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  position: fixed;
  inset: 0;
  z-index: 1000;
`;

export const ModalBodyStyled = styled.div`
  position: relative;
  display: flex;
  min-width: 32rem;
  max-width: 40rem;
  margin: calc(1rem + 5vh) 0;

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    min-width: 90%;
    width: 90%;
  }

  animation-duration: 1s;
  animation-name: appear;
  padding: 0.75rem 2rem 2rem 2rem;

  p,
  ul {
    line-height: 1.4;
    margin: 1.5rem 1rem;
  }

  animation-iteration-count: 1;
  animation-timing-function: cubic-bezier(0.69, 0.39, 0.44, 0.76);
  background-color: ${({ theme }) => theme.baseColors.white};
  border-radius: ${({ theme }) => theme.cardBorderRadius};
`;

export const ModalContentStyled = styled.div`
  flex: 1 1 auto;
  overflow: auto;
`;

export const ModalCloseButtonStyled = styled.button`
  background-color: ${({ theme }) => theme.baseColors.white};
  border-radius: 2rem;
  border-style: none;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.15);
  color: ${({ theme }) => theme.baseColors.base50};
  min-height: 2.5rem;
  padding: 0;
  position: absolute;
  right: calc(-0.5rem - 0.5vw);
  top: calc(-0.5rem - 0.5vw);
  width: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${({ theme }) => theme.baseColors.white};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const ModalCloseIconStyled = styled(Icon)`
  display: flex;
  place-items: center;
`;
